export const TESTIMONIALS = [
  {
    image: "/images/avatars/01.png",
    name: "Pat",
    description: "Stayed 7 days",
    review: `Hi, I am Pat from the Basque Country.
Never had a better place in India.
Peaceful, clean, pool included, only a 5-minute walk from the beach – for only 800 rupees a night, maybe the best choice year-round. I’ll be back for sure. Easy to find because it's near the Church of Piety.
Decorated with so many beautiful and original items you can never get bored. A cool place to be in such hot weather and with a wonderful host and hostess that you don’t even want to go to the beach.`,
  },
  {
    image: "/images/avatars/02.png",
    name: "Lobo",
    description: "Stayed 4 days",
    review: `The owner, Antonio, is very good. Very hospitable, giving a personal touch by ensuring that we are well looked after. The room rate is fantastic.
His daughter, Ayesha, and wife, Lorraine, are very accommodating and friendly. A family atmosphere.

Will visit them again.

Recommend visiting the Love Shack, which is owned by Indian Kitchen, for some great cocktails on the beach. The people in the shack are very friendly and speak English.`,
  },
  {
    image: "/images/avatars/03.png",
    name: "Jessie L",
    description: "Stayed 6 days",
    review: `Fabulous place, the surroundings are cozy, quiet, and away from the noise. Close walking distance to Baga and Calangute beaches. Excellent services and value for money.
This is the most amazing hotel I have ever stayed at. The staff, service, cleanliness, rooms... Not a single fault! The brunch was indescribable and a must-try for anyone visiting. We loved the food.`,
  },
  {
    image: "/images/avatars/05.png",
    name: "Tatiana",
    description: "Stayed 3 days",
    review: `I arrived a week ago. Nice service, beautiful room with a large terrace, enjoying my stay in quiet Goa. My big terrace is very comfortable for cooking salads, enjoying breakfast, and practicing my singing arts. My room is beautiful, with a marble floor featuring deep blue lapis azure tones...`,
  },
  {
    image: "/images/avatars/04.png",
    name: "Tom A.",
    description: "Stayed 2 days",
    review: `Stayed here for a few days in November of this year. The family that runs it is so helpful and friendly. This place was so cheap compared to other places in Calangute/Baga. The pool is an added bonus for only £9 per night for a double room, which included an attached bathroom with a hot shower, fridge, cable TV, kettle, balcony, and wardrobes. The location couldn’t be better – it’s off the main road at the end of Calangute and the start of Baga, just a 5-minute walk from the beach. However, it wouldn’t be needed because of the peacefulness poolside.
Overall, a great place, lovely staff, and would recommend it to all.`,
  },
  {
    image: "/images/avatars/06.png",
    name: "Billy",
    description: "Stayed 5 days",
    review: `We didn't stay here as we were visiting friends but used the restaurant here several times during our holiday. The food and service were both excellent every time, and the setting is peaceful and very pretty, away from the hectic roads of Baga.`,
  },
];